<template>
  <div class="background-notification-window" @click.self="closeWindow">
    <div class="notifications-container">
      <div class="notifications-header">
        <h1 class="notifications-title">Уведомления</h1>
        <button class="close-button" @click="closeWindow">Закрыть</button>
      </div>

      <p class="no-notifications" v-show="!notifications">Пока уведомлений нет</p>

      <div class="notifications">
        <div v-show="notifications" v-for="(notification, index) in notifications" :key="index" class="notification-item"
          :class="'type-' + (notification.type_message? notification.type_message : 'info')">
          <div class="notification-header">
            <span class="company" v-if="userOptions.role == 'developer'">{{ notification.company }}</span>
            <span class="date">{{ notification.time_mark? notification.time_mark : "Нет временной метки" }}</span>
            <!-- <span class="type-badge">{{ typeLabels[notification.type_message] }}</span> -->
          </div>
          <div class="notification-content">
            <p>{{ notification.message }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  emits: ['closeWindow'],
  data() {
    return {
      typeLabels: {
        info: 'Информация',
        warning: 'Предупреждение',
        error: 'Ошибка',
        success: 'Успех'
      },
      notifications: []
    }
  },
  computed: {
    ...mapGetters({
      notesFromStore: 'getNotifications'
    }),
    ...mapGetters('user', {
      userOptions: 'getUserOptions',
    })
  },
  methods: {
    ...mapActions(['getNotifications']),
    closeWindow() {
      this.$emit('closeWindow')
    }
  },

  async created() {
    await this.getNotifications()
    this.notifications = this.notesFromStore
  }

}
</script>

<style scoped>
.background-notification-window {
  position: absolute;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.295);
}
.close-button {
  margin-right: 20px;
  background-color: #e74c3c;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 0.9em;
  transition: background-color 0.3s ease;
  margin-bottom: 39px;

}

.close-button:hover {
  background-color: #c0392b;
}


.no-notifications {
  margin-top: 20px;
  text-align: center;
}

.notifications {
  overflow-y: scroll;
  height: 87%;
}

.notifications-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.notifications-title {
  padding-top: 10px;
  padding-left: 10px;
  margin-bottom: 50px;
}

.notifications-container {
  padding-left: 3px;
  
  top: 0;
  right: 0;
  margin-left: 65%;
  background-color: white;

  max-width: 100%;
  height: 100%;
  z-index: 10;

}

h2 {
  color: #333;
  margin-bottom: 20px;
}

.notification-item {
  border-left: 4px solid #ccc;
  padding: 15px;
  margin-bottom: 15px;
  background: #f9f9f9;
  border-radius: 4px;
}

.notification-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 0.9em;
}

.company {
  font-weight: bold;
  color: #2c3e50;
}

.date {
  color: #7f8c8d;
}

.type-badge {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.8em;
  color: white;
}

.notification-content p {
  margin: 0;
  color: #34495e;
}


.type-info {
  border-left-color: #3498db;
}

.type-info .type-badge {
  background: #3498db;
}

.type-warning {
  border-left-color: #f39c12;
}

.type-warning .type-badge {
  background: #f39c12;
}

.type-error {
  border-left-color: #e74c3c;
}

.type-error .type-badge {
  background: #e74c3c;
}

.type-success {
  border-left-color: #2ecc71;
}

.type-success .type-badge {
  background: #2ecc71;
}
</style>
